var BACKGROUND_CAPTURE_DEVICE_MODES = ['desktop', 'tablet', 'mobile'];
export var parseBackgroundCaptureDeviceMode = function (value) {
    if (typeof value !== 'string') {
        return undefined;
    }
    return BACKGROUND_CAPTURE_DEVICE_MODES.includes(value)
        ? value
        : undefined;
};
//# sourceMappingURL=background-capture-types.js.map